export default "__VITE_ASSET__913dd1d1__"